<div *ngIf="showSplash" class="app-splash-screen">
    <div class="app-splash-logo">
        <img src="/Content/xpress-app/images/xpress_logo_black.svg" style="width: 300px" />
    </div>
    <div class="app-splash-inner">
        The robots at work setting things up, this may take a few minutes....
    </div>
    <ng-lottie width="600px" [options]="options" [styles]="styles"></ng-lottie>
</div>
